export default {
  login: {
    userName: process.env.VUE_APP_LOGIN_USERNAME,
    password: process.env.VUE_APP_LOGIN_PASSWORD
  },
  backend: {
    url: process.env.VUE_APP_API_URL
  },
  env: process.env.NODE_ENV,
  webroute:process.env.VUE_APP_WEB_ROUTE,
  approute:process.env.VUE_APP_APP_ROUTE,
  adminroute:process.env.VUE_APP_ADMIN_ROUTE,
  intl: {
    locale: 'sv-SE'
  },
  route: {
    www: process.env.VUE_APP_WWW_URL,
    shop: process.env.VUE_APP_WEBSHOP_URL,
    admin: process.env.VUE_APP_ADMIN_URL
  }
  
}